import orderLocationService from '../services/order-location'
import {
  SET_ORDER_LOCATIONS,
  SET_ORDER_LOCATIONS_LOADING,
  SET_ORDER_LOCATIONS_ERROR,
  REMOVE_ORDER_LOCATION
} from '../mutation-types'

// State
export const state = {
  orderLocations: [],
  loading: false,
  error: null
}

// Getters
export const getters = {
  orderLocations: state => state.orderLocations,
  activeOrderLocations: state => state.orderLocations.filter(loc => loc.is_active),
  orderLocationsLoading: state => state.loading,
  orderLocationsError: state => state.error
}

// Mutations
export const mutations = {
  [SET_ORDER_LOCATIONS](state, orderLocations) {
    state.orderLocations = orderLocations
  },

  [SET_ORDER_LOCATIONS_LOADING](state, loading) {
    state.loading = loading
  },

  [SET_ORDER_LOCATIONS_ERROR](state, error) {
    state.error = error
  },

  [REMOVE_ORDER_LOCATION](state, id) {
    state.orderLocations = state.orderLocations.filter(loc => loc.id !== id)
  }
}

// Actions
export const actions = {
  async fetchOrderLocations({ commit }, { admin = false } = {}) {
    commit(SET_ORDER_LOCATIONS_LOADING, true)
    commit(SET_ORDER_LOCATIONS_ERROR, null)
    try {
      const { data } = admin
        ? await orderLocationService.getAllAdmin()
        : await orderLocationService.getAll()
      commit(SET_ORDER_LOCATIONS, data.results || [])
      return data
    } catch (error) {
      commit(SET_ORDER_LOCATIONS_ERROR, error.response?.data?.message || 'Failed to fetch order locations')
      throw error
    } finally {
      commit(SET_ORDER_LOCATIONS_LOADING, false)
    }
  },

  async fetchActiveOrderLocations({ commit }) {
    commit(SET_ORDER_LOCATIONS_LOADING, true)
    commit(SET_ORDER_LOCATIONS_ERROR, null)
    try {
      const { data } = await orderLocationService.getAll()
      commit(SET_ORDER_LOCATIONS, data.results || [])
      return data
    } catch (error) {
      commit(SET_ORDER_LOCATIONS_ERROR, error.response?.data?.message || 'Failed to fetch order locations')
      throw error
    } finally {
      commit(SET_ORDER_LOCATIONS_LOADING, false)
    }
  },

  async createOrderLocation({ commit, dispatch }, payload) {
    commit(SET_ORDER_LOCATIONS_LOADING, true)
    try {
      const { data } = await orderLocationService.create(payload)
      await dispatch('fetchOrderLocations', { admin: true })
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_ORDER_LOCATIONS_LOADING, false)
    }
  },

  async updateOrderLocation({ commit, dispatch }, { id, payload }) {
    commit(SET_ORDER_LOCATIONS_LOADING, true)
    try {
      const { data } = await orderLocationService.update(id, payload)
      await dispatch('fetchOrderLocations', { admin: true })
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_ORDER_LOCATIONS_LOADING, false)
    }
  },

  async deleteOrderLocation({ commit, dispatch }, id) {
    commit(SET_ORDER_LOCATIONS_LOADING, true)
    try {
      const { data } = await orderLocationService.delete(id)
      commit(REMOVE_ORDER_LOCATION, id)
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_ORDER_LOCATIONS_LOADING, false)
    }
  },

  async updateOrderLocationOrder({ commit, dispatch }, ids) {
    commit(SET_ORDER_LOCATIONS_LOADING, true)
    try {
      const { data } = await orderLocationService.updateOrder(ids)
      await dispatch('fetchOrderLocations', { admin: true })
      return data
    } catch (error) {
      throw error
    } finally {
      commit(SET_ORDER_LOCATIONS_LOADING, false)
    }
  }
}
